import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { SERVICE_HISTORY_MODELS } from '@repo/shared-types';

import type { ServiceHistoryModel } from '@repo/shared-types';

interface ModelSelectProps {
  value: ServiceHistoryModel;
  onChange: (model: ServiceHistoryModel) => void;
  disabled?: boolean;
}

/** Picks which Gemini model reads the files. */
export const ModelSelect = ({ value, onChange, disabled }: ModelSelectProps) => (
  <Select
    value={value}
    onValueChange={(next) => onChange(next as ServiceHistoryModel)}
    disabled={disabled}
  >
    <SelectTrigger className="w-[280px]">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {SERVICE_HISTORY_MODELS.map((model) => (
        <SelectItem key={model.value} value={model.value}>
          {model.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
